<template>
	<div class="home">
		<!-- Header -->
		<Header :headerTitle="$t('m.home.title')" :AddressBtn="true" :hasBackBtn="false"
			:rightIconSrc="require('../assets/img/wode.png')" :onRightBtnClick="onRightBtnClick"
			:addressClick="addressClick" :address="$i18n.locale==='zh_CN'? addressCity.name : addressCity.enName"
			:iconShow="true"></Header>
		<div class="main-container" style="padding-top:0;" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
			infinite-scroll-distance="200">
			<!-- parkingList -->
			<b-card tag="article" class="mb-1" v-for="(parKingItem,index) in parkingResult" :key="index"
				v-if="parkingResult!=''">
				<div class="media-container">
					<b-media right-align vertical-align="center" style="height:180px;width:100%">
						<!-- <b-img :src="parKingItem.logoUrl" slot="aside" width="200px" height="100px"/> -->
						<img :src="parKingItem.logoUrl" height="180px" width="100%"
							@click="funcReadImgInfo(parKingItem.logoUrl)" alt="图片加载失败" />
					</b-media>
					<div class="go-there" @click="go(parKingItem)" v-if="c == null">
						{{ $t('m.home.goTo') }}
						<p class="numM">{{ parKingItem.distance|convert }}km</p>
					</div>

					<div class="info">
						<p style="margin: 0 0 5px 0;width: 100%;">
              <strong>{{ $i18n.locale === 'zh_CN' ? parKingItem.name : parKingItem.enName }}</strong>
              <span v-if="parKingItem.selfService === 1" class="auto-parking-label">无人值守</span>
              <span v-if="parKingItem.selfService === 1" class="auto-parking-use-rule" @click="goAutoParkingUseRule">使用规则</span>
						</p>
						<p style="display: inline-block;margin:0;">
							{{ $i18n.locale === 'zh_CN' ? parKingItem.addressDetails : parKingItem.enAddressDetails}}
						</p>
						<p style="display: inline-block;margin:0;">
							{{ $i18n.locale === 'zh_CN' ? parKingItem.address : parKingItem.enAddress }}
						</p>
					</div>
				</div>
				<!-- button -->
				<b-button href="#" variant="primary"
					style="border:0px;margin:0 10px;width:90% !important;margin:0 auto;margin-left: 5% !important;">
					<p style="margin:0;"
						@click="appointment(parKingItem.id,parKingItem.latitude,parKingItem.longitude, parKingItem.selfService)">
						{{ $t('m.home.button') }}
					</p>
				</b-button>
			</b-card>
			<div v-if="parkingResult==''">{{ $t('m.home.dataNull') }}</div>
		</div>
		<!-- 提示信息 -->
		<Tip :message="message" :type="tipType" :show="tipShow"></Tip>
		<b-modal ref="limitOrderCount" id="limitOrderCount" centered hide-header ok-only :ok-title="$t('m.home.ok')">
			<h5>{{ $t('m.home.unfulfilledOrder') }}</h5>
		</b-modal>

    <b-modal ref="notFromH5Modal" id="notFromH5Modal" style="margin-top: 100px" centered hide-header ok-only :ok-title="$t('m.home.ok')">
      <h5>{{ $t('m.home.notFromH5') }}</h5>
    </b-modal>

		<b-modal ref="disperserSelect" class="cancelOrders" :cancel-title="$t('m.confirmOrder.modelCancel')"
			:ok-title="$t('m.confirmOrder.modelOk')" @cancel="disabledBtn = true" @ok="disperserOrder()">
			<p class="my-4" style="margin-bottom:5px !important;padding:0 25px;font-size:15px;">
				{{ $t('m.confirmOrder.tipsModel1') }}
			</p>
			<p class="my-4" style="margin-bottom:5px !important;padding:0 25px;font-size:13px;color:#0066B1;">
				({{ $t('m.confirmOrder.tipsModel2') }})</p>
		</b-modal>

		<b-modal ref="disperserSelectSP" class="cancelOrders" :ok-title="$t('m.confirmOrder.ok')"
			@ok="disabledBtn = true" ok-only>
			<p class="my-4" style="margin-bottom:5px !important;padding:0 25px;font-size:15px;">
				{{ $t('m.confirmOrder.tipsModel3') }}
			</p>
		</b-modal>

		<b-modal ref="notice" class="notice" ok-only :ok-title="$t('m.home.ok')" @ok="goAppoint()">
			<p class="my-3"
				style="text-align:left;margin-bottom:5px !important;padding:0 25px;font-size:15px;white-space:pre-line" v-html="noticeInfo">
<!--				{{ noticeInfo }}-->
			</p>
		</b-modal>

    <b-modal ref="announcement" class="announcementNotice"  ok-only :ok-title="$t('m.home.ok')" @ok="goAppoint()">
<!--      <img class="back-img" width="100%" src="../assets/img/gonggao.png" />-->
      <div class="announcementImg" @click="go(parKingItem)" v-if="c == null">

      </div>
    </b-modal>

		<b-modal ref="notice-space" class="notice" ok-only :ok-title="$t('m.home.ok')">
			<p class="my-3"
				style="text-align:center;margin-bottom:5px !important;padding:0 25px;font-size:15px;"
      >
				{{ noticeInfo }}
			</p>
			<!-- <p style="font-size:0.9rem;font-weight:bold;margin-top:1rem">
        {{$t('m.home.noticeFooter')}}
        <a
          style="color:#0066B1;font-size:0.9rem;margin-top:1rem;font-weight:light"
          href="tel:400-115-0606"
        >400-115-0606</a>
      </p> -->
		</b-modal>

    <b-modal ref="notice-vehicle-license" id="notice-vehicle-license" no-close-on-backdrop class="notice" static ok-title="去认证"
             cancel-title="选择其他场站" @ok="goVehicleLicenseAuth()" @cancel="handleVehicleLicenseCancel">
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:14px;">
        预约无人值守场站需进行车辆认证，
      </p>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:14px;">
        您尚未进行车辆认证，是否去认证？
      </p>
    </b-modal>

		<b-modal ref="notice-image" id="notice-image" no-close-on-backdrop class="notice" static ok-title="了解福利"
			cancel-title="下次再说" @ok="goNoticeDetail()" @cancel="dontGoNoticeDetail">
			<b-img :src="noticeImage.imageUrl" fluid alt="Responsive image"></b-img>
			<h5 style="margin-top: 12px"><b><strong>{{ noticeImage.title }}</strong></b></h5>
			<p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:12px;">
				{{ noticeImage.subtitle }}
			</p>
		</b-modal>
	</div>
</template>

<script>
	import {
		parkingList
	} from "../api/parking.js";
	import {
		loginBind,
		wxCode as getWxCodeInfo
	} from "../api/login.js";
	import {
		placeCanOrder,
		placeAnOrder
	} from "../api/order.js";
	import {
		userOrderStatus
	} from "../api/order.js";
	import {
		getCity
	} from "../api/address.js";
	import {
		getCookie,
		setCookie
	} from "../utils/CookieUtil.js";
	import {
		userInfo
	} from "../api/user.js";
	import {
		formatDateAppoint
	} from "@/utils/DateFomatUtil";
	import {
		getBrowserType,
		getLonLat
	} from '@/utils/common.js'

	export default {
		name: "Home",
		data() {
			return {
				c: null,
				browserType: null,
				chargeType: "",
				parkingId: null,
				placeEmpty: true,
				parkingResult: [], //列表数据
				wxCode: "", //
				orderLong: 116.61685188029097,
				orderLat: 40.05186171596531,
				longitude: 116.61685188029097, //当前经度
				latitude: 40.05186171596531, //当前维度
				orderId: "", //订单列表
				status: "", //状态
				page: 1, //当前页
				pageSize: 20, //显示多少条
				busy: false, //分页滚动加载
				total: 0, //数据总数
				message: "", //提示信息
				tipShow: "0", //是否提示
				tipType: "", //提示类型
				addressCity: {
					id: 1
				}, //头部显示城市
				currentCity: {}, //当前城市
				carType: null,
				isCarIdRequired: false,
				provinceName: "京",
				lencesNumber: "",
				appointHour: 1,
				orderShow: true,
				hasDisperser: 0,
				positionStatus: true,
				noticeInfo: '',
				noticeTitle: '',
				noticeImage: {
					title: '',
					imageUrl: '',
					subtitle: ''
				},
        selfService: undefined
			};
		},
		methods: {
			funcReadImgInfo(value) {
				WeixinJSBridge.invoke(
					"imagePreview", {
						current: value,
						urls: [value]
					},
					function(res) {}
				);
			},
      goVehicleLicenseAuth() {
        this.$router.push("/vehicleLicenseAuth");
      },
      handleVehicleLicenseCancel() {
      },
      goAutoParkingUseRule() {
        this.$router.push("/autoParkingIUseRule");
      },
			goAppoint() {
				let isTemporary = null; //是否临牌
				if (!this.isCarIdRequired) {
					isTemporary = 2;
				} else if (this.isCarIdRequired) {
					isTemporary = 1;
				}
				let carName = this.provinceName + this.lencesNumber.replace(/[^\w]/gi, "").toUpperCase(); //车牌号
				this.datePickerSelectAppointInTimeStr = formatDateAppoint("yyyy-MM-dd hh:mm", new Date());
				let dateTimesa = this.datePickerSelectAppointInTimeStr + ":00";
				let subData = {
					isTemporary: isTemporary,
					licenseplate: carName,
					appointInTime: dateTimesa,
					appointTime: this.appointHour,
					parkingId: this.parkingId,
					longitude: this.longitude,
					latitude: this.latitude
				};
				placeCanOrder(subData).then(response => {
          if (response.data.status === 50020) {
            this.noticeTitle = '温馨提示'
            this.noticeInfo = '预约无人值守场站需进行车辆认证，\n您尚未进行车辆认证，是否去认证？'
            this.$refs["notice-vehicle-license"].show();
            return;
          }

					if (response.data.status !== 200) {
						this.noticeInfo = response.data.message
						this.$refs["notice-space"].show();
						return;
					}

					this.placeEmpty = response.data.result.flag;
					if (response.data.result.chargeType != "") {
						this.chargeType = response.data.result.chargeType;
					} else {
						this.chargeType = 0;
					}

					this.hasDisperser = response.data.result.hasDisperser;
					if (this.placeEmpty === true) {
						this.hasDisperser = 0
						userOrderStatus({
							parkingId: this.parkingId
						}).then(
							response => {
								if (response.data.result) {
									this.orderId = response.data.result.orderId;
									this.status = response.data.result.status;
									let extraPayStatus = response.data.result.extraPayStatus;
                  let notFromH5 = response.data.result.notFromH5;
                  if (notFromH5 === 2) {
                    this.$refs.notFromH5Modal.show();
                    return;
                  }

									if (extraPayStatus == 2) {
										this.$router.push("/excessOrder/" + this.orderId);
										return;
									} else if ((extraPayStatus == 3 && this.status == 3) || this.status == 5) {
										this.$refs.limitOrderCount.show();
										return;
									} else if (extraPayStatus == 2 && this.status == 6) {
										this.$router.push("/excessOrder/" + this.orderId);
										return;
									}
									//跳转待支付页面
									if (this.status == 1) {
										this.$router.push("/submitOrder/" + this.orderId);
									} else if (this.status == 2) {
										// 跳转待进场页面
										var type = 0;
										this.$router.push(
											"/staySubmitOrder/" + this.orderId + "/" + type
										);
									} else if (this.status == 5) {
										//跳转待超时支付页面
										this.$router.push("/overtimeOrder/" + this.orderId);
									}
									//跳转计时页面
									else if (this.status == 3) {
										this.$router.push("/Time/" + this.orderId);
									} else {
										this.$router.push("/confirmOrder/" + this.parkingId + "/" + this
											.orderLat + "/" + this.orderLong + "/" + this.placeEmpty +
											"/" + this.chargeType + "/" + this.hasDisperser);
									}
								} else {
                  sessionStorage.setItem('pakring-self-service' + this.parkingId, this.selfService)
									this.$router.push("/confirmOrder/" + this.parkingId + "/" + this.orderLat +
										"/" + this.orderLong + "/" + this.placeEmpty + "/" + this
										.chargeType + "/" + this.hasDisperser);
								}
							}
						);
					} else {
						if (this.hasDisperser === 1) {
							this.$refs["disperserSelect"].show();
						} else if (this.hasDisperser === 2) {
							this.$refs["disperserSelectSP"].show();
						}
					}
				});
			},

			//去预约操作
			appointment: function(id, latitude, longitude, selfService) {
				this.orderLong = longitude;
				this.orderLat = latitude;
				this.parkingId = id;
        this.selfService = selfService

        // if (id === 61 || id === 65) {
        //   this.$refs["announcement"].show();
        //   return;
        // }

        if (id === 70) { // 70
          this.noticeInfo = '亲爱的宝马车主朋友们:\n' +
              '为了给您提供更加智能、便捷、高效的充电服务,BMW专属预约停车充电站北京国贸站将于2023年7月24日起进行升级改造，预计于2023年8月24日恢复营业。给您带来不便,敬请谅解!场站升级期间建议使用My BMW App合理安排充电计划。升级后的充电场站将为您带来前所未有的优质充电体验,敬请期待!\n' +
              '<div style="text-align: right">2023年7月20日</div>';
          this.$refs["notice"].show();
          return;
        }
        if (id === 68) { // 68
          this.noticeInfo = '亲爱的宝马车主朋友们:\n' +
              '为了给您提供更加智能、便捷、高效的充电服务,BMW专属预约停车充电站北京东方广场站将于2023年7月24日起进行升级改造，预计于2023年8月24日恢复营业。给您带来不便,敬请谅解!场站升级期间建议使用My BMW App合理安排充电计划。升级后的充电场站将为您带来前所未有的优质充电体验,敬请期待!\n' +
              '<div style="text-align: right">2023年7月20日</div>'
          this.$refs["notice"].show();
          return
        }
        if (id === 63) { // 63
          this.noticeInfo = '亲爱的宝马车主朋友们:\n' +
              '为了给您提供更加智能、便捷、高效的充电服务,BMW专属预约停车充电站沈阳万象城站将于2023年7月24日起进行升级改造，预计于2023年8月24日恢复营业。给您带来不便,敬请谅解!场站升级期间建议使用My BMW App合理安排充电计划。升级后的充电场站将为您带来前所未有的优质充电体验,敬请期待!\n' +
              '<div style="text-align: right">2023年7月20日</div>'
          this.$refs["notice"].show();
          return
        }

				this.goAppoint()
				// if (id === 64) {
				// 	this.noticeInfo =
				// 		'尊敬的宝马车主：\n根据政府疫情防控安排，沈阳万象汇宝马专属服务区自2022年9月15日开始，营业时间调整为10:00-20:00，恢复时间另行通知，给您造成的不便敬请谅解，让我们一起携手同心，共抗疫情！\n2022年9月15日'
				// 	this.$refs["notice"].show();
				// } else {
				// 	this.goAppoint()
				// }
			},
			known() {},

			go(parKingItem) {
				let thiss = this;
				wx.openLocation({
					latitude: Number(parKingItem.latitude), // 纬度，浮点数，范围为90 ~ -90
					longitude: Number(parKingItem.longitude), // 经度，浮点数，范围为180 ~ -180。
					name: thiss.$i18n.locale === "zh_CN" ?
						parKingItem.address : parKingItem.enAddress, // 位置名
					address: thiss.$i18n.locale === "zh_CN" ?
						parKingItem.addressDetails : parKingItem.enAddressDetails, // 地址详情说明
					scale: 12 // 地图缩放级别,整形值,范围从1~28。默认为最大
				});
			},
			//用户中心
			onRightBtnClick: function() {
				this.$router.push("/userCenter");
			},

			disperserOrder() {
				userOrderStatus({
					parkingId: this.parkingId
				}).then(
					response => {
						let latitude = this.orderLat;
						let longitude = this.orderLong;
						if (response.data.status == 200) {
							if (response.data.result) {
								this.orderId = response.data.result.orderId;
								this.status = response.data.result.status;
								let extraPayStatus = response.data.result.extraPayStatus;
								if (extraPayStatus == 2) {
									this.$router.push("/excessOrder/" + this.orderId);
									return;
								} else if (
									(extraPayStatus == 3 && this.status == 3) ||
									this.status == 5
								) {
									this.$refs.limitOrderCount.show();
									return;
								} else if (extraPayStatus == 2 && this.status == 6) {
									this.$router.push("/excessOrder/" + this.orderId);
									return;
								}
								//跳转待支付页面
								if (this.status == 1) {
									this.$router.push("/submitOrder/" + this.orderId);
								} //跳转待进场页面
								else if (this.status == 2) {
									var type = 0;
									this.$router.push(
										"/staySubmitOrder/" + this.orderId + "/" + type
									);
								} //跳转待超时支付页面
								else if (this.status == 5) {
									this.$router.push("/overtimeOrder/" + this.orderId);
								}
								//跳转计时页面
								else if (this.status == 3) {
									this.$router.push("/Time/" + this.orderId);
								} else {
									this.$router.push("/confirmOrder/" + this.parkingId + "/" + latitude + "/" +
										longitude + "/" + this.placeEmpty + "/" + this.chargeType + "/" + this
										.hasDisperser);
								}
							} else {
								this.$router.push("/confirmOrder/" + this.parkingId + "/" + latitude + "/" +
									longitude + "/" + this.placeEmpty + "/" + this.chargeType + "/" + this
									.hasDisperser);
							}
						} else {
							this.tipShow = "1" + Math.random() * 1000;
							this.message = response.data.message;
							this.tipType = "warning";
						}
					}
				);
			},

			//登录检查是否绑定微信
			loadCheckBind: function() {
				if (localStorage.getItem("token") == null) {
					this.getWxCode();
					loginBind({
						wxCode: this.wxCode
					}).then(
						response => {
							if (response.data.status === 200 || response.data.status === 309) {
								if (response.data.result.token != null) {
									localStorage.setItem("token", response.data.result.token);
									this.loadUserInfo();
								} else {
									this.$router.push("/login");
								}
								if (response.data.result.openId != null) {
									localStorage.setItem("openId", response.data.result.openId);
								}
							} else {
								this.tipShow = "1" + Math.random() * 1000;
								this.message = response.data.message;
								this.tipType = "warning";
							}
						}
					);
				}
			},
			//获取WXCode
			getWxCode() {
				let code = this.getQueryString("code");
				if (code === undefined || code == null) {
					//未获取到WXCode
					console.log("未获取到WXCode");
				} else {
					this.wxCode = code;
				}
			},
			getQueryString(name) {
				let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				let r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);
				return null;
			},

			wxReady() {
				return new Promise((resolve, reject) => {
					let wxReady = setInterval(() => {
						if (this.wxJSAPIReady) {
							resolve(true);
							clearInterval(wxReady);
						}
					}, 100);
				});
			},

			//获取当前地址
			getPosition() {
				let thiss = this;
				return new Promise((resolve, reject) => {
					wx.getLocation({
						type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
						success: function(res) {
							// let speed = res.speed; // 速度，以米/每秒计
							thiss.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90;
							thiss.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
							// let accuracy = res.accuracy; // 位置精度
							resolve(res);
						}
					});
				});
			},
			getPositionByBro() {
				let thiss = this;
				return new Promise((resolve, reject) => {
					if ('geolocation' in navigator) {
						let options = {
							enableHighAccuracy: true,
							timeout: 5000,
							maximumAge: 0
						}

						function succFun(position) {
							thiss.latitude = position.coords.latitude
							thiss.longitude = position.coords.longitude
							let res = {
								latitude: position.coords.latitude,
								longitude: position.coords.longitude
							}
							resolve(res);
						}

						function error(err) {
							console.log("用户拒绝获取位置信息")
						}

						navigator.geolocation.getCurrentPosition(succFun, error, options)
					} else {
						console.log("无法获取您的位置!")
					}
				})
			},
			//获取当前城市
			getCurrentCity: function() {
				let thiss = this;
				return new Promise((resolve, reject) => {
					getCity({
						latitude: thiss.latitude,
						longitude: thiss.longitude
					}).then(
						response => {
							if (response.data.status === 200) {
								if (response.data.result != null) {
									this.currentCity = response.data.result;
									setCookie("cityItemId", this.currentCity.id);
									resolve(response.data.result);
								}
							} else {
								thiss.tipShow = "1" + Math.random() * 1000;
								thiss.message = response.data.message;
								thiss.tipType = "warning";
							}
						},
						err => {
							reject(err);
						}
					);
				});
			},
			//查询方法
			parkingList: function() {
				let req = {
					page: this.page,
					city: this.addressCity.id,
					pageSize: this.pageSize,
					latitude: this.latitude,
					longitude: this.longitude
				};
				if (sessionStorage.getItem("c")) {
					req['c'] = sessionStorage.getItem("c");
				}
				parkingList(req).then(
					response => {
						if (response.data.status === 200) {
							if (this.page === 1) {
								//刚进入应用首页刷新定位时用
								this.parkingResult = response.data.result;
							} else {
								//分页用
								response.data.result.forEach(d => {
									this.parkingResult.push(d);
									//把值放入这个数组中
								});
							}
							this.total = response.data.total;
							this.busy = false;
						} else {
							this.tipShow = "1" + Math.random() * 1000;
							this.message = response.data.message;
							this.tipType = "warning";
						}
					}
				);
			},
			//分页刷新
			loadMore() {
				this.busy = true;
				let pages = Math.ceil(this.total / this.pageSize);
				if (this.page < pages) {
					this.page++;
					this.parkingList();
				} else {
					this.busy = false;
				}
			},
			addressClick() {
				this.$router.push({
					name: "addressList",
					params: {
						currentCity: this.currentCity
					}
				});
			},
			loadUserInfo: function() {
				userInfo().then(response => {
					if (response.data.status === 200) {
						if (response.data.result.licenseplate === "临") {
							this.isCarIdRequired = true;
						} else {
							let parkName = response.data.result.licenseplate;
							if (!parkName) {
								if(sessionStorage.getItem("c")){
									this.provinceName = "京";
								}else {
									this.provinceName = "粤";
								}

							} else {
								this.provinceName = parkName.substr(0, 1);
								this.lencesNumber = parkName.substr(1, 8);
							}
							// sessionStorage.setItem("provinceName", this.provinceName);
						}
					}
				});
			},
			goNoticeDetail() {
				sessionStorage.setItem("notice-image-go", 1);
				this.$router.push({
					name: "noticeDetail"
				});
			},
			dontGoNoticeDetail() {
				sessionStorage.setItem("notice-image-go", 1);
			}
		},
		created() {
			let lang = this.getQueryString("lang") || "zh_CN";
			localStorage.setItem("lang", lang);
			this.$i18n.locale = lang;

			let c = this.getQueryString(("c")) || '';
			if (c) {
				this.c = c;
				this.provinceName = "粤";
				sessionStorage.setItem("c", c);
			}
			this.browserType = getBrowserType()
			if (!this.c) {
		       this.loadCheckBind()
			}
			if (!this.c) {
				//未登录(无token)时不请求定位，直接调列表接口由拦截器跳转登录页，避免定位授权弹窗出现在登录页
				if (localStorage.getItem("token")) {
					this.wxReady().then(response => {
						this.getPosition().then(response => {
							this.getCurrentCity().then(response => {
								if (flag) {
									this.addressCity = response;
								}
								this.parkingList();
								this.positionStatus = false;
							});
						});
					});
				} else {
					this.parkingList();
				}
			} else {
				this.longitude = 114.064552
				this.latitude = 22.572753
				this.orderLong = 114.064552
				this.orderLat = 22.572753
				// this.getPositionByBro().then(response => {
				this.getCurrentCity().then(response => {
					// if (flag) {
					this.addressCity = response;
					// }
					this.parkingList();
					this.positionStatus = false;
				});
				// });
			}
		},
		mounted() {
			if(!this.c){
				let lang = this.getQueryString("lang") || "zh_CN";
				localStorage.setItem("lang", lang);
				this.$i18n.locale = lang;

				let c = this.getQueryString(("c")) || '';
				if(c){
					this.c = c;
					this.provinceName = "粤"
					sessionStorage.setItem("c", c);
				}
			}
			if (!this.c) {
				getWxCodeInfo().then(res => {
					console.log(res)
				})
			}
		},

		filters: {
			convert: function(val) {
				return (val / 1000).toFixed(1);
			}
		},
		activated() {
			this.parkingResult = {};
			//测试阶段不使用 this.loadCheckBind();
			let cityId = parseInt(getCookie("cityItemId"));
			let cityName = getCookie("cityItemName");
			let cityEnName = getCookie("cityItemEnName");
			let flag = true;
			if (cityId && cityName && cityEnName) {
				flag = false;
				this.addressCity.id = cityId;
				this.addressCity.name = cityName;
				this.addressCity.enName = cityEnName;
				this.parkingList();
			} else {
				//未登录(无token)时不请求定位，避免定位授权弹窗出现在登录页；下方 positionStatus 仍会触发列表接口跳转登录
				if (localStorage.getItem("token") && this.browserType === 1) {
					this.wxReady().then(response => {
						this.getPosition().then(response => {
							this.getCurrentCity().then(response => {
								if (flag) {
									this.addressCity = response;
								}
								this.parkingList();
								this.positionStatus = false;
							});
						});
					});
				}else{
					// this.getPositionByBro().then(response => {
					// 	this.getCurrentCity().then(response => {
					// 		if (flag) {
					// 			this.addressCity = response;
					// 		}
					// 		this.parkingList();
					// 		this.positionStatus = false;
					// 	});
					// });
				}
				if (this.positionStatus) {
					this.parkingList();
				}
			}

			let noticeImageGo = sessionStorage.getItem("notice-image-go");
			if (!noticeImageGo && cityId === 2) {
				// 弹窗
				this.noticeImage.title = '为 BMW 车主保驾护航'
				this.noticeImage.subtitle = 'BMW 预约停车充电, 北京部分机场限时免费停车'
				this.noticeImage.imageUrl = 'https://zimg.chinasinoair.com/74481704e3294fd8ab575aa23a1b1638?f=jpg'
				// this.$refs["notice-image"].show();
			}
			/* else if(!noticeImageGo && cityId === 494) {
			      this.noticeImage.title = '为 BMW 车主保驾护航'
			      this.noticeImage.subtitle = 'BMW 预约停车充电, 沈阳部分机场限时免费停车'
			      this.noticeImage.imageUrl = 'https://zimg.chinasinoair.com/4e69d675a40e4e11266a836c4a316f6a?f=jpg'
			      this.$refs["notice-image"].show();
			    }*/
			else {
				// this.$refs["notice-image"].hide();
			}
		}
	};
</script>
<style>
	.notice .modal-content {
		margin: 0 auto;
		margin-top: 200px;
		width: 95%;
	}

	.notice .modal-header {
		padding: 0rem;
	}

	.home {
		/* dis */
		background: #f0f0f0;
	}

  .announcementNotice .modal-content {
    margin-top: 100px;
    margin-left: 9px;
    width: 95%;
  }

  .announcementNotice .modal-header {
    padding: 0rem;
  }

  .announcementNotice .modal-body {
    padding-bottom: 0rem;
  }

  .announcementNotice .modal-footer {
    border-top: none;
  }


  .main-container .media-container .info {
		background-color: #fff !important;
		color: #575757;
		padding: 10px 10px;
		margin-bottom: 5px;
	}

	.main-container .media-container .info p {
		width: 80%;
	}

	.main-container .card-body a {
		background-color: #0061b1;
		line-height: 30px;
	}

	.main-container .card {
		background-color: #fff !important;
		padding: 0 0 16px 0 !important;
		padding-bottom: 10px !important;
		border: none !important;
		border-radius: 0 !important;
		margin-top: 15px;
	}

	.media {
		background-color: #0061b1;
		text-align: center;
		vertical-align: middle;
	}

	.media .media-body {
		/* padding: 15px 0px; */
		font-size: 12px;
		color: #ffffff;
		display: inline-block !important;
	}

	.media-body p {
		vertical-align: middle;
		display: inline-block !important;
		margin: 0 auto;
	}

	.media-body p strong {
		margin-top: 35px;
	}

	.d-flex {
		margin: 0px auto;
	}

	.card .btn {
		width: 100% !important;
	}

	.card-body {
		padding: 0 !important;
		text-align: left;
	}

	.media-container {
		position: relative;
	}

	.media-container .go-there {
		background: url(../assets/img/lasigou.png) no-repeat;
		background-size: 100%;
		width: 47px;
		height: 47px;
		position: absolute;
		right: 7px;
		bottom: 20px;
		/* top: 40px; */
		padding-top: 24px;
		text-align: center;
		font-size: 9px;
		color: rgb(233, 233, 233);
	}

  .announcementImg {
    background: url(../assets/img/gonggao.png) no-repeat;
    background-size: 100%;
    height: 480px;
  }

	.media-container .go-there-2 {
		width: 47px;
		height: 47px;
		position: absolute;
		right: 7px;
		bottom: 20px;
		/* top: 40px; */
		padding-top: 24px;
		text-align: center;
		font-size: 9px;
		color: rgb(233, 233, 233);
	}

	.numM {
		display: inline-block;
		margin: 0;
		float: right;
		margin-top: 6px;
		margin-right: 6px;
		bottom: 0px !important;
		color: black;
		font-size: 15px;
	}

	.modal-content {
		border-radius: 13px;
	}

	#modalsm___BV_modal_header_ {
		padding-bottom: 5px;
	}

	.modal-title {
		width: 100%;
		text-align: center;
		font-size: 16px;
	}

	.close {
		display: none;
	}

	.modal-footer .btn-secondary {
		width: 100%;
	}

	#modalsm___BV_modal_body_ {
		padding: 0 40px;
		padding-top: 15px;
	}

	.imgSize {
		width: 30%;
		display: inline-block !important;
	}

	#limitOrderCount .modal-body {
		padding-bottom: 0;
	}

	#limitOrderCount .modal-body h5 {
		font-size: 1.02rem;
		margin: 10px 0;
	}

	#limitOrderCount .modal-footer {
		padding: 10px;
	}

	#limitOrderCount .modal-footer .btn-primary {
		width: 0%;
		line-height: 1.9rem;
		font-size: 1.05rem;
		letter-spacing: 2.2px;
		background-color: #0061b1;
		/* background-color: #666; */
		text-align: center;
		border: 0px;
	}

	#notice-image .modal-footer {
		border-top: 0px
	}

	#notice-image footer .btn-primary {
		background-color: black;
		color: white;
		font-weight: bold;
		border-color: black;
	}

	#notice-image .modal-footer .btn-secondary {
		background-color: white;
		color: black;
		font-weight: bold;
		border-color: white;
	}

	#notice-image .modal-body {
		padding: 0;
	}

	#notice-image .modal-content {
		border-radius: 0.5rem;
		border: 0px;
	}

	#notice-image .img-fluid {
		border-top-left-radius: 0.5rem;
		border-top-right-radius: 0.5rem;
		margin-top: -1px;
	}

  .auto-parking-label {
    width: 88px;
    height: 30px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0061B1;
    line-height: 24px;
    margin-left: 8px;
    border: 1px solid #0061B1;
    border-radius: 4px;
    background: #F3FAFF;
    padding: 1px 2px;
  }

  .auto-parking-use-rule {
    width: 80px;
    height: 28px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0061B1;
    line-height: 24px;
    margin-left: 8px;
  }
</style>
